import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Box, HStack, Spinner} from 'native-base';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppText from "./AppText";
import { GlobalConsts } from "../../styles/GlobalConsts";
import orderBy from "lodash-es/orderBy";
import {Dropdown, Tooltip} from "antd";
import {solid, light} from "@fortawesome/fontawesome-svg-core/import.macro";
import {IconSwitcher} from "../Icons8Generator/IconSwitcher";
import {Colors} from "../../styles/Colors";
import {isMobile} from "../../services/Helpers";
import {t} from "../../services/i18n";

const DropDownMenu = props => {
    const { items, title, onPress, fontSize, boldFont, sortAlphabetically, textStyles, width, showBorder, tooltipText, styleOverride = {}, menuStyle, error } = props;
    const [itemsNew, setItemsNew] = useState(items);

    useEffect(() => {
        const temp = items.reduce((acc, item) => [...acc, {...item, label: item.name ?? item.title, key: JSON.stringify(item)}],[])
        if(sortAlphabetically) {
            const sorted = orderBy(temp, [item => item.name.toLowerCase()], ['asc'])
            setItemsNew(sorted)
        } else {
            setItemsNew(temp)
        }
    }, [sortAlphabetically, items]);

    const onItemSelect = ({key}) => {
        const item = JSON.parse(key)
        onPress(item.id)
    }

    const getSelectedDisplay = () =>
        <div className={`custom-dropdown ${showBorder ? 'border' : ''} ${error ? 'error' : ''}`} style={styleOverride}>
            <AppText fontSize={fontSize} boldFont={boldFont || false} style={textStyles}>{title}</AppText>
            <FontAwesomeIcon icon={solid('chevron-down')} fontSize={GlobalConsts.iconSize.XXS} style={{marginLeft: 5, marginRight: 5}}/>
        </div>

    return (
        <>
             {itemsNew.length > 1 ?
                 <Dropdown
                     menu={{items: itemsNew, onClick: onItemSelect, style: menuStyle}}
                     trigger={['click']}
                     overlayStyle={{width: width ?? 'auto'}}
                 >
                     {tooltipText ?
                         <Tooltip title={tooltipText} placement={GlobalConsts.menu.placement.TOP}>
                            {getSelectedDisplay()}
                        </Tooltip>
                         :
                         getSelectedDisplay()
                     }
                 </Dropdown>
                 :
                <AppText fontSize={fontSize} boldFont={boldFont || false} style={textStyles}>
                    {title}
                </AppText>
            }
        </>
    );
}

export default DropDownMenu;